module.exports = __webpack_public_path__ + "static/media/Portraits-9.c7f222dc.jpg";